"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomUIEventEnum = void 0;
var CustomUIEventEnum;
(function (CustomUIEventEnum) {
    CustomUIEventEnum["AddVoucher"] = "ADD_VOUCHER";
    CustomUIEventEnum["RemoveVoucher"] = "REMOVE_VOUCHER";
    CustomUIEventEnum["NavigateToCart"] = "evelin:navigate:cart";
})(CustomUIEventEnum || (exports.CustomUIEventEnum = CustomUIEventEnum = {}));
//# sourceMappingURL=CustomUIEventEnum.js.map